controllers.controller('CreateFirstAccountController', [
    '$scope', '$state', '$ionicLoading', 'LocaleService', 'UserService', 'AccountService',
    'Utils', 'Storage', 'constants', 'CountryService',
    function ($scope, $state, $ionicLoading, LocaleService, UserService, AccountService,
              Utils, Storage, Const, CountryService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.currencyList = Storage.get('currencies');
        $scope.countries = CountryService.get();
        $scope.user = UserService.get();
        $scope.constants = Const;

        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false,
            isProcess: false
        };

        var maxLiveAccounts = Storage.get('maxLiveAccounts');

        $scope.createAccount = function () {
            var isLive = true;
            var currency = getUserBaseCurrency() || Utils.getCurrencyByCountry($scope.user.country, $scope.countries, $scope.currencyList);

            $ionicLoading.show();
            return AccountService.createAccount(isLive, currency)
                .then(Utils.wait(2000))
                .then(function (response) {
                    return AccountService.switchAccount(response.mt4Account.login, isLive)
                })
                .then(function () {
                    $ionicLoading.hide();
                    return Utils.getURLParameterByName('action') === Const.depositActionName ? $state.go('root.app.wallet') : $state.go('root.app.assets')
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.isError = true;
                    $scope.modal.textTitle = (error && LocaleService.translation.messages[error.code]&& LocaleService.translation.messages[error.code].replace(/\%X\%/, maxLiveAccounts)) || LocaleService.translation.messages.general_error;
                    $scope.modal.textContent = "";
                    $scope.modal.state = true;
                })
        };

        $scope.logout = function () {
        };

        function getUserBaseCurrency() {
            var userCurrency = $scope.user.baseCurrency;
            if (!userCurrency) return;

            return _.find($scope.currencyList, {currency: userCurrency}) && userCurrency;
        }

        if (Const['autoUpdatePersonalDetails'] && !Const['skipCreateFirstAccountPage']) {
            $scope.createAccount();
        }

        $scope.$on('$ionicView.beforeEnter', function () {
            if (Const['skipCreateFirstAccountPage']) {
                $scope.createAccount();
            }
        });

    }]);
